import tinycolor from "tinycolor2";
import { ColourPicker, FormGroup, Input, Label, PencilIcon } from "@mwi/ui";
import ColourTypes from "types/colours";

type ColourSectionProps = {
  title: string;
  description: string;
  value: string;
  onChange: (colours: ColourTypes) => void;
};

const ColourSection = ({
  title,
  description,
  value,
  onChange,
}: ColourSectionProps): JSX.Element => {
  const handleOnChange = (colour: string) => {
    if (/^[a-fA-F0-9\s#]*$/.test(colour)) {
      onChange({
        rgb: tinycolor(colour).toRgb(),
        hex: colour.indexOf("#") !== -1 ? colour : `#${colour}`,
        hsl: tinycolor(colour).toHsl(),
      });
    }
  };

  return (
    <>
      <div className="flex flex-col gap-y-4 mb-9">
        <h3 className="!text-lg font-semibold">{title}</h3>
        <p className="!text-lg ">{description}</p>
      </div>

      <div
        className="w-full h-24 mb-6 bg-primary"
        style={{
          backgroundColor: tinycolor(value).toString("rgb"),
        }}
      />

      <FormGroup
        className="grid tablet:grid-cols-3 desktop:grid-cols-4 gap-x-6"
        hideError
      >
        <div className="tablet:col-span-2 desktop:col-span-3">
          <Label>Hex Code</Label>
        </div>

        <div className="grid items-center tablet:grid-cols-3 desktop:grid-cols-4 gap-x-6 col-span-full">
          <div className="tablet:col-span-2 desktop:col-span-3">
            <Input
              maxChars={7}
              size="large"
              value={value}
              onChange={(e) => handleOnChange(e.target.value)}
            />
          </div>

          <div className="col-end-auto">
            <ColourPicker
              value={value}
              panelClassName="!-top-40"
              onChange={onChange}
              trigger={() => (
                <PencilIcon className="w-8 h-8 text-black cursor-pointer" />
              )}
            />
          </div>
        </div>
      </FormGroup>
    </>
  );
};

export default ColourSection;
